let winX = null
let winY = null

window.addEventListener('scroll', () => {
  if (winX !== null && winY !== null) {
    window.scrollTo(winX, winY)
  }
})

function disableWindowScroll() {
  winX = window.scrollX
  winY = window.scrollY
}

function enableWindowScroll() {
  winX = null
  winY = null
}

export { disableWindowScroll, enableWindowScroll }
